export default "images/postgresql-logo.png";